import React from 'react';
import { Switch, Route, withRouter } from 'react-router-dom';

import Overview from './Overview';
import New from './New';
import Detail from './Detail';
import Edit from './Edit';
import Modal from '../../../components/Modal';

const NewsModule = props => {
  const paths = {
    details: `${props.match.path}/:id`,
    edit: `${props.match.path}/edit/:id`,
    search: `${props.match.path}/search/:search?`,
    new: `${props.match.path}/new`,
  };

  return (
    <Modal title='Branchenmagazin'>
      <Switch>
        <Route path={paths.new} component={New} />
        <Route path={paths.search} component={Overview} />
        <Route path={paths.edit} component={Edit} />
        <Route path={paths.details} component={Detail} />
        <Route component={Overview} />
      </Switch>
    </Modal>
  );
};

export default withRouter(NewsModule);
